import { TRIGGER_TYPE_LABEL } from "../../../features/builder.constants";
import { CASE_STATUS, toOptions } from "../../features/monitor.constants";

// Advanced filter of the Cases list. Every key must also be in FILTER_FIELDS of the backend's
// reminder_monitor/instance/controller.js, the whitelist get-all filters on.
export const instanceFilterFields = [
  { key: "status", label: "Status", type: "enum", group: "Case", options: toOptions(CASE_STATUS) },
  { key: "rule_fid", label: "Rule", type: "select", group: "Case", optionsKey: "rules", optionLabel: "name", optionValue: "id" },
  { key: "trigger_type", label: "Trigger type", type: "enum", group: "Case", options: toOptions(TRIGGER_TYPE_LABEL) },
  { key: "current_step", label: "Step", type: "int", group: "Case" },
  { key: "subject_user_fid", label: "User id", type: "int", group: "Case" },
  { key: "next_due_at", label: "Next due", type: "datetime", group: "Dates" },
  { key: "last_sent_at", label: "Last sent", type: "datetime", group: "Dates" },
  { key: "created_date", label: "Opened", type: "datetime", group: "Dates" },
];
